import React from 'react';
import {Global, css} from '@emotion/react';

const iOSStyles = `
  @supports (-webkit-touch-callout: none) {
    .modal-content {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
    
    .modal-scroll {
      -webkit-overflow-scrolling: touch;
      overscroll-behavior: contain;
    }
  }
`;

export const GlobalStyle = () => (
    <Global
        styles={css`
            :root {
                --safe-top: max(env(safe-area-inset-top, 0px), var(--safe-top-rn, 0px));
                --safe-bottom: max(env(safe-area-inset-bottom, 0px), var(--safe-bottom-rn, 0px));
                --safe-bottom-keyboard: calc(var(--safe-bottom) + var(--keyboard-height, 0px));
                --foreground: #ffffff;
                --background: #f2f2f2;
                --font-default: #222222;
                --max-width: 500px;
            }
            ${iOSStyles}
            html,
      body,
      div,
      span,
      applet,
      object,
      iframe,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      p,
      blockquote,
      pre,
      a,
      abbr,
      acronym,
      address,
      big,
      cite,
      code,
      del,
      dfn,
      em,
      img,
      ins,
      kbd,
      q,
      s,
      samp,
      small,
      strike,
      strong,
      sub,
      sup,
      tt,
      var,
      b,
      u,
      i,
      center,
      dl,
      dt,
      dd,
      ol,
      ul,
      li,
      fieldset,
      form,
      label,
      legend,
      table,
      caption,
      tbody,
      tfoot,
      thead,
      tr,
      th,
      td,
      article,
      aside,
      canvas,
      details,
      embed,
      figure,
      figcaption,
      footer,
      header,
      hgroup,
      menu,
      nav,
      output,
      ruby,
      section,
      summary,
      time,
      mark,
      audio,
      video {
                margin: 0;
                padding: 0;
                border: 0;
                font-size: 100%;
                font: inherit;
                vertical-align: baseline;
                font-family:
                    'Pretendard',
                    -apple-system,
                    BlinkMacSystemFont,
                    system-ui,
                    Roboto,
                    'Helvetica Neue',
                    'Segoe UI',
                    'Apple SD Gothic Neo',
                    'Noto Sans KR',
                    'Malgun Gothic',
                    sans-serif;
            }

            article,
            aside,
            details,
            figcaption,
            figure,
            footer,
            header,
            hgroup,
            menu,
            nav,
            section {
                display: block;
            }
            html {
                height: 100dvh;
                overflow-y: hidden;
            }
            body {
                height: 100dvh;
                min-height: 100vh; /* fallback */
                min-height: 100dvh; /* 최신 브라우저 */
            }
            #root {
                margin-left: auto;
                margin-right: auto;
                max-width: var(--max-width);
                height: 100dvh;
                position: relative;
                background-color: var(--foreground, #ffffff);
                padding-top: var(--safe-top);
                padding-bottom: var(--safe-bottom-keyboard);
                transition: padding-bottom 200ms ease;
                overflow-y: hidden;
                overscroll-behavior: none;
                touch-action: none;
            }
            body {
                line-height: 1;
                -webkit-overflow-scrolling: touch;
                background-color: var(--background, #f2f2f2);
                overflow-y: hidden;
                padding: 0;
                margin: 0;
                overflow-x: hidden;
                -ms-overflow-style: none;
                scrollbar-width: thin;
                font-family: 'Pretendard', sans-serif;
            }

            body.no-scroll {
                overflow: hidden;
                position: relative;
                touch-action: none;
                overscroll-behavior: none;
            }

            ol,
            ul {
                list-style: none;
            }

            blockquote,
            q {
                quotes: none;
            }

            blockquote:before,
            blockquote:after,
            q:before,
            q:after {
                content: '';
                content: none;
            }

            table {
                border-collapse: collapse;
                border-spacing: 0;
            }

            input,
            textarea,
            select,
            button {
                margin: 0;
                padding: 0;
                border: 0;
                font-size: 100%;
                font: inherit;
                vertical-align: baseline;
                font-family: 'Pretendard', sans-serif;
                background: transparent;
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
                border-radius: 0;
            }

            input:focus,
            textarea:focus,
            select:focus {
                outline: none;
                border-radius: 0;
            }

            button:focus {
                outline: none;
            }

            input[type='number']::-webkit-inner-spin-button,
            input[type='number']::-webkit-outer-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }

            input[type='number'] {
                appearance: textfield;
                -moz-appearance: textfield;
            }

            input[type='search']::-webkit-search-decoration,
            input[type='search']::-webkit-search-cancel-button,
            input[type='search']::-webkit-search-results-button,
            input[type='search']::-webkit-search-results-decoration {
                -webkit-appearance: none;
            }
            ::-webkit-scrollbar {
                display: none;
            }

            /* Firefox */
            * {
                scrollbar-width: none;
            }

            /* IE, 구버전 Edge */
            * {
                -ms-overflow-style: none;
            }

            input:-webkit-autofill,
            input:-webkit-autofill:hover,
            input:-webkit-autofill:focus,
            input:-webkit-autofill:active {
                -webkit-text-fill-color: #000;
                -webkit-box-shadow: 0 0 0px 1000px #fff inset;
                box-shadow: 0 0 0px 1000px #fff inset;
                transition: background-color 5000s ease-in-out 0s;
            }

            input:autofill,
            input:autofill:hover,
            input:autofill:focus,
            input:autofill:active {
                -webkit-text-fill-color: #000;
                -webkit-box-shadow: 0 0 0px 1000px #fff inset;
                box-shadow: 0 0 0px 1000px #fff inset;
                transition: background-color 5000s ease-in-out 0s;
            }

            select::-ms-expand {
                display: none;
            }

            // ios 및 안드로이드, PC 동일한 placeholder 색상 맞춤
            input::placeholder,
            textarea::placeholder,
            input::-webkit-input-placeholder,
            textarea::-webkit-input-placeholder {
                color: #cccccc;
                opacity: 1;
            }

            button {
                color: inherit;
                cursor: pointer;
                border: none;
                background: none;
                padding: 0;
                -webkit-tap-highlight-color: transparent;
                -webkit-touch-callout: none;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
                touch-action: manipulation;
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
            }

            button:active {
                -webkit-tap-highlight-color: transparent;
                outline: none;
                -webkit-touch-callout: none;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
            }

            button:disabled {
                cursor: not-allowed;
            }

            /* 모든 클릭 가능한 요소에 터치 피드백 제거 */
            div,
            svg,
            a,
            li,
            button,
            [onClick],
            [role='button'],
            .clickable,
            .dropdown-value,
            .dropdown-option,
            .tab-wrapper,
            .dropdown,
            .current-month-year,
            .navigation-buttons button,
            .date-range-picker-input-wrapper,
            .date-range-picker-input-button,
            .custom-calendar-header button,
            .react-datepicker__day,
            .react-datepicker__day-name,
            .react-datepicker__month,
            .react-datepicker__year,
            .react-datepicker__decade,
            .react-datepicker__century,
            .react-datepicker__navigation,
            .react-datepicker__navigation--previous,
            .react-datepicker__navigation--next,
            .react-datepicker__header__dropdown,
            .react-datepicker__month-dropdown,
            .react-datepicker__year-dropdown,
            .react-datepicker__month-option,
            .react-datepicker__year-option,
            svg[onClick],
            div[onClick],
            span[onClick],
            a[onClick],
            li[onClick] {
                -webkit-tap-highlight-color: transparent;
                -webkit-touch-callout: none;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
                touch-action: manipulation;
            }

            [onClick]:active,
            [role='button']:active,
            .clickable:active,
            .dropdown-value:active,
            .dropdown-option:active,
            .tab-wrapper:active,
            .dropdown:active,
            .current-month-year:active,
            .navigation-buttons button:active,
            .date-range-picker-input-wrapper:active,
            .date-range-picker-input-button:active,
            .custom-calendar-header button:active,
            .react-datepicker__day:active,
            .react-datepicker__day-name:active,
            .react-datepicker__month:active,
            .react-datepicker__year:active,
            .react-datepicker__decade:active,
            .react-datepicker__century:active,
            .react-datepicker__navigation:active,
            .react-datepicker__navigation--previous:active,
            .react-datepicker__navigation--next:active,
            .react-datepicker__header__dropdown:active,
            .react-datepicker__month-dropdown:active,
            .react-datepicker__year-dropdown:active,
            .react-datepicker__month-option:active,
            .react-datepicker__year-option:active,
            svg[onClick]:active,
            div[onClick]:active,
            span[onClick]:active,
            a[onClick]:active,
            li[onClick]:active {
                -webkit-tap-highlight-color: transparent;
                outline: none;
                -webkit-touch-callout: none;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
            }

            a {
                color: var(--font-default, #222222);
                text-decoration: none;
            }

            *,
            *::before,
            *::after {
                -moz-box-sizing: border-box;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
            }

            .scroll-bar {
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;
                scrollbar-gutter: stable;

                &::-webkit-scrollbar {
                    width: 0px; // 스크롤바 안보이도록 변경 25.08.11
                }

                &::-webkit-scrollbar-track {
                    background-color: #f1f1f1;
                }

                &::-webkit-scrollbar-thumb {
                    background-color: #ccc;
                    border-radius: 4px;
                }
            }

            .scroll-bar-x {
                overflow-x: auto;
                -webkit-overflow-scrolling: touch;
                scrollbar-gutter: stable;

                &::-webkit-scrollbar {
                    height: 0px; // 스크롤바 안보이도록 변경 25.08.11
                }

                &::-webkit-scrollbar-track {
                    background-color: #f1f1f1;
                }

                &::-webkit-scrollbar-thumb {
                    background-color: #ccc;
                    border-radius: 4px;
                }
            }

            .loading-description {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #222;
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                letter-spacing: -0.28px;
            }
        `}
    />
);
